import { createApp } from "vue"

import "bootstrap/dist/css/bootstrap.css"
import "vue-utils/dist/style.css"
import "./css/app.scss"

import "./extensions"

import { isInPopup } from "oidc-vue"
import App from "./App"
import { AppAuthContext } from "./authentication"
import router from "./pages/routes"

AppAuthContext.options.router = router
await AppAuthContext.initialize()
if (!isInPopup()) {
	try {
		if (await AppAuthContext.needsSignIn()) {
			AppAuthContext.user = null
			await AppAuthContext.userManager.signinRedirect()
		}
	} catch (e) {
		console.error(e)
	}

	const app = createApp(App)
	app.use(router)
	app.use(AppAuthContext)

	if (document.readyState === "loading") {
		await new Promise((resolve) => document.addEventListener("DOMContentLoaded", resolve))
	}
	app.mount("#app")
}
